import React, { useEffect, useState } from 'react';
import RSSFeedView from '../../components/RSSFeedView';
import Api from '../../services/Api';

const Main = () => {
  const [feed, setFeedData] = useState([]);

  useEffect(() => {
    const getRssFeedData = async () => {
      const data = await Api.getFeedData();
      setFeedData(data);
    };
    getRssFeedData();
  }, []);

  return (
    <RSSFeedView podcastList={feed} />
  );
};

export default Main;
